import styled from "styled-components";
import color from "../../styles/color";

export const Container = styled.div`
//border: 1px solid ${color.lightgray};
// resize: horizontal;
//  position: relative;
  margin-top: 1px;
  margin-left: 20px;
//  margin-right: 10px;
//  margin-bottom: 10px;
// overflow-x: auto;
// overflow-y: hidden;
// padding: 10px;
 //border-radius: 10px;

.header{
  display:inline-block;
  font-size : 0.8rem;
  margin-right: 10px;
  height : 10px;
  
}
.App{
    display:inline-block;
    width: 220px;
    height: 10px;
}


`;

